export default __webpack_public_path__ + "static/media/D539BACC-BE5F-48BC-AF76-CF0EE67D7802_1_105_c.c96823d5.jpeg";